import { render, staticRenderFns } from "./edit-package-modal.vue?vue&type=template&id=18091da8"
import script from "./edit-package-modal.vue?vue&type=script&lang=js"
export * from "./edit-package-modal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports